// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck - may need to be at the start of file
import React, {FC, useEffect, useState} from 'react';
import { Logger } from '@fkhplus/common/src/utils/logger';
import { PlatformUtils } from '@fkhplus/common/src/utils/PlatformUtils';
import OTPVerification from '@fkhplus/common/src/components/molecules/OTPVerification/OTPVerification';

interface IOtpWrapperweb {
  onSubmitOTP:()=> void
}


const OtpWrapperweb: FC<IOtpWrapperweb> = (props: IOtpWrapperweb) => {
  const [otp, setOtp] = useState<string>('0');

    useEffect(()=>{
        if(PlatformUtils.isWeb()){
          onSmsListener()
        }
      
      },[])

      
    const onSmsListener = async () => {
      if ("OTPCredential" in window || true) {
        const ac = new AbortController();
        setOtp(String(0));
        navigator.credentials
          .get({
            otp: { transport: ["sms"] },
            signal: ac.signal
          })
          .then((otp) => {
            setOtp(String(otp.code));
            ac.abort();
          })
          .catch((err) => {
            ac.abort();
            Logger.info(err);
          });
      }
      };

    return (
            <OTPVerification 
            otp={otp} 
            key={otp}
            resetListner={()=>onSmsListener()}  
            onSubmitOTP={props.onSubmitOTP}/>
    );
};
export default OtpWrapperweb;
